import { Component, inject, ViewChild } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import {MatListModule} from '@angular/material/list';
import { NavigationMenuItem } from '../nav-menu-item.model';
import { useNavigationMenu } from '../nav-menu-composable';
import { Router } from '@angular/router';
import { PermissionService } from '../../../../services/permission.service';
import { CHECK_PERMISSIONS } from '@shared/modules/permissions.module';
import { SHARED_MENU_IMPORTS } from '@shared/modules/shared-menu-module';

@Component({
  selector: 'side-drawer-menu',
  imports: [MatSidenavModule, ...SharedMaterialUIModule, MatListModule, ...SHARED_MENU_IMPORTS],
  templateUrl: './side-drawer-menu.html',
  styles: ``,
})
export class SideDrawerMenu {
  readonly router = inject(Router);
  readonly items: NavigationMenuItem[] = useNavigationMenu().menuItems;
  private readonly permissionService = inject(PermissionService);
  protected readonly verifyPermissions = CHECK_PERMISSIONS();
  @ViewChild('sidenav') sidenav!: MatSidenav;
   navigateTo(route: string) {
    this.router.navigate([route]);
    this.sidenav.toggle();
  }
}
